import React, { useCallback, useEffect, useState } from 'react';

import CourseGroupSelect from '../CourseGroupSelect';
import styles from './CourseGroupInput.module.scss';

const parseCourseGroup = (courseGroup) =>
  courseGroup
    ? {
        label: courseGroup?.name,
        value: courseGroup?.id,
      }
    : null;

function CourseGroupInput({ value, onChange, disabled = false }) {
  const [courseGroup, setCourseGroup] = useState(parseCourseGroup(value));

  useEffect(() => {
    if (value) {
      setCourseGroup(parseCourseGroup(value));
    } else {
      setCourseGroup(null);
    }
  }, [value]);

  const handleCourseGroupChange = useCallback(
    (option) => {
      setCourseGroup(option);
      onChange({
        ...value,
        name: option?.label,
        id: option?.value,
      });
    },
    [onChange, value]
  );
  return (
    <CourseGroupSelect
      value={courseGroup}
      onChange={handleCourseGroupChange}
      className={styles.input}
      isDisabled={disabled}
    />
  );
}

export default CourseGroupInput;
